class RoutingService {
    private pathArray: string[] = []

    public pathChanged(path: string): void {
        this.pathArray = path.split('/')
    }

    public getFragment(index: number): string {
        return this.pathArray[index + 1]
    }
}

export default new RoutingService() as RoutingService
